export default "__VITE_ASSET__ab48a07e__"